import { Timestamp} from './db';

const maxGapBetweenWords = 4;   // seconds; a word after more starts a new phrase

//TODO should this be Phrase class?

//TODO split into smaller functions
//TODO write unit tests
export function groupWordsIntoPhrases(words) {
    const withGaps = words.map((word, index, words) => {
        if (index < words.length - 1) {
            const nextWord = words[index + 1];
            //TODO better calculation, need also use nanoseconds field
            const gap = nextWord.timestamp.seconds - word.timestamp.seconds;
            return { word, gap }
        } else {
            return { word, gap: 0 }
        }
    });
    //TODO use hashmap instead of list for search
    const delimiters = ['.', '!', '?', ';'];
    const withDelimiters = withGaps.map(wordInfo => {
        const lastChar = wordInfo.word.text.slice(-1);
        const isEndingWithDelimiter = (delimiters.includes(lastChar));
        const isPhraseEnd = isEndingWithDelimiter || wordInfo.gap > maxGapBetweenWords;
        return {
            ...wordInfo,
            isPhraseEnd 
        };
    });
    const phrases = [];
    let lastPhrase = []
    for (const [i, wordInfo] of withDelimiters.entries()) {
        lastPhrase.push(wordInfo.word);
        if (wordInfo.isPhraseEnd || i === withDelimiters.length - 1) {
            phrases.push(lastPhrase);
            lastPhrase = [];
        }
    }
    return phrases;
}

export function phraseAge(words) {
    //TODO better calculation (use nanoseconds)
    return Timestamp.now().seconds - words[words.length - 1].timestamp.seconds;
}
